export class AccountSource {
  static CONTEXT = 'CONTEXT'
  static TOKEN = 'TOKEN'
  static ARGS = 'ARGS'
}
